import fetch from '@/utils/fetch';
import { message } from 'antd';

const expressInfoInit = {
  shipping_type: 1,
  free_shipping_type: 1,
  express_freight: [
    {
      region: '0',
      first_num: '1',
      first_cost: '8.00',
      extend_num: '1',
      extend_cost: '8.00',
    },
  ],
};

const getFormattedData = (data) => {
  if (data.express_freight) {
    if (data.express_freight.length > 0) {
      data.express_freight.forEach((row) => {
        Object.keys(row).forEach((key) => {
          if (key.includes('_cost')) {
            row[key] = (row[key] / 100).toFixed(2);
          }
        });
      });
    } else {
      data.free_shipping_type = expressInfoInit.free_shipping_type;
      data.express_freight = [...expressInfoInit.express_freight];
    }
  }
  // 如果省市相同 则填区
  data.province_city = [data.province, data.province === data.city ? data.county : data.city];
  // 不删除此处的值
  // delete data.province;
  // delete data.city;
  // 如果有定位信息 设置zoom为15 否则为4
  data.zoom = data.longitude && data.latitude ? 15 : 4;
  // 为地图设置默认地址 坐标
  data.longitude = data.longitude || 108.483525;
  data.latitude = data.latitude || 35.254578;
  data.province = data.province || '陕西省';
  data.city = data.city || '咸阳市';
  data.county = data.county || '旬邑县';
  return data;
};
const getFormattedValues = (values) => {
  values.express_freight &&
    values.express_freight.forEach((row) => {
      Object.keys(row).forEach((key) => {
        if (key.indexOf('_cost') > -1) row[key] *= 100;
      });
    });
  const [province, city] = values.province_city;
  delete values.province_city;
  return { ...values, province, city };
};

const model = {
  state: {
    // 基本信息
    showShopInfo: true,
    shopInfoLoading: false,
    shopInfo: {},
    // 微信支付
    showPayInfo: true,
    payInfoLoading: false,
    payInfo: {},
    // 微众支付
    showWeBankPayInfo: true,
    weBankPayInfoLoading: false,
    weBankPayInfo: {},
    exportLoading: false,
    weBankBillList: [],
    weBankBillListTotal: 0,
    weBankBillListLoading: false,
    // 微众支付
    wePayLoading: false,
    // 订单语音播报
    audioLoading: false,
    audioSwitch: null,
    audioNoticeRound: 0,
    // 到店付语音播报
    fastPayStatus: 0,
    // 出餐对应的开关提醒
    deliveryOrderNotice: false,
    // 预约单对应提醒
    receiveOrderNoticeStatus: false,
    // 退款申请语音播报状态
    refundStatus: 0,
    // 客服消息
    switchLoading: false,
    switchStatus: {},
    phoneStatus: 0,
    phone: null,
    // 是否显示重新提交按钮
    showResubmit: false,
    // 子门店分账
    subAccountList: [],
    subAccountTotal: 0,
    subAccountPageSize: 10,
    subAccountLoading: false,
    operateList: [],
    operateTotal: 0,
    operateListLoading: false,
    submitShopLoading: false,
    deleteShopLoading: false,
    searchShopList: [],
    searchShopLoading: false,
    modalShopList: [], // 弹窗时查询的shopList，为了不与外部的list列表冲突
    modalShopLoading: false,
    // 是否支持款易
    kuan1_status: false,
    // 是否支持寿光
    shouguang_status: false,
    // 是否支持手动刷新数据
    tp_refresh_able: false,
    htMch_name: '',
    htMch_id: '',
    subInfoList: [],
    subInfoTotal: 0,
    htSubShopList: [{ sub_shop_id: null, shop_name: null }],
    htAccountList: [],
    accountCode: { shop_name: null, url: null },
    usable_payment: [{ mch_id: 1, mch_name: '' }],
    htAccountTotal: null,
    applyHtSubShopList: [{ sub_shop_id: null, shop_name: null, is_opened: 0 }],
    htShopName: null,
    htShopId: null,
    // 接单提醒
    audioReceiveSwitch: false,
    audioReceiveTime: 30,
    // 出餐提醒
    diningOutSwitch: false,
    diningOutTime: 30,
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { settings }, getState }) => ({
    // 基本信息
    setShopInfoVisible(visible) {
      settings.setState({ showShopInfo: visible });
    },
    async getShopInfo() {
      const { shop_id } = getState().basic;
      settings.setState({ shopInfoLoading: true });
      const data = await fetch('/merchant/shop/getshopdetail', { params: { shop_id } });
      settings.setState({ shopInfoLoading: false });
      if (data) {
        settings.setState({ shopInfo: getFormattedData(data) });
      }
    },
    setShopInfo(newState) {
      const shop_info = getState().settings.shopInfo;
      settings.setState({ shopInfo: { ...shop_info, ...newState } });
    },
    updateShopInfo(form) {
      const { shop_id } = getState().basic;
      const shop_info = getState().settings.shopInfo;
      form.validateFieldsAndScroll(async (err, values) => {
        if (err) return;
        // 重新定义参数 *省市区信息使用shop_info内的
        const formValues = { ...getFormattedValues(values) };
        delete formValues.province;
        delete formValues.city;
        const params = { ...shop_info, ...formValues };
        delete params.zoom;
        delete params.province_city;
        const data = await fetch('/merchant/shop/update', {
          type: 'POST',
          params: { ...params, shop_id },
        });
        if (data) {
          message.success('保存成功');
          settings.getShopInfo();
          settings.setState({ showShopInfo: true });
        }
      });
    },
    // 支付信息
    // 微信支付
    setPayInfoVisible(visible) {
      settings.setState({ showPayInfo: visible });
    },
    // 微众支付
    setWeBankPayInfoVisible(visible) {
      settings.setState({ showWeBankPayInfo: visible });
    },
    async getWeBankPayInfo() {
      const { shop_id } = getState().basic;
      settings.setState({ weBankPayInfoLoading: true });
      const data = await fetch('/merchant/shop/getwbpayconf', {
        params: { shop_id },
      });
      settings.setState({ weBankPayInfoLoading: false });
      if (data) {
        settings.setState({ showWeBankPayInfo: true, weBankPayInfo: data });
      } else if (data === null) {
        settings.setState({ showWeBankPayInfo: false, weBankPayInfo: {} });
      }
    },
    updateWeBankPayInfo(form) {
      const { shop_id } = getState().basic;
      form.validateFieldsAndScroll(async (err, values) => {
        if (err) return;
        const data = await fetch('/merchant/shop/wbpaybind', {
          type: 'POST',
          params: { ...values, shop_id },
        });
        if (data) {
          message.success('保存成功');
          settings.getWeBankPayInfo();
          settings.setState({ showWeBankPayInfo: true });
        }
      });
    },
    setSubAccountPageSize(page_size) {
      settings.setState({ subAccountPageSize: page_size });
    },
    async searchShops(value, key) {
      const { shop_id } = getState().basic;
      const loadingKey = key.replace('List', 'Loading');
      settings.setState({ [loadingKey]: true });
      const data = await fetch('/merchant/shop/subshoplist', {
        params: { shop_id, shop_name: value, cur_page: 0, per_page: 0 },
      });
      settings.setState({ [key]: data ? data.sub_shop_list : [], [loadingKey]: false });
    },
    async submitSubShop(params, type) {
      const { shop_id } = getState().basic;
      settings.setState({ submitShopLoading: true });
      const data = await fetch(
        type === 'add' ? '/merchant/shop/addsubshoppayinfo' : '/merchant/shop/updatesubshoppayinfo',
        {
          type: 'POST',
          params: { shop_id, ...params },
        },
      );
      settings.setState({ submitShopLoading: false });
      return data;
    },
    // 重置audioSwitch状态
    resetAudioSwitch() {
      settings.setState({ audioSwitch: null });
    },
    // 获取接单提醒设置
    async getReceiveOrderNoticeStatus() {
      const { shop_id } = getState().basic;
      settings.setState({ switchLoading: true, audioLoading: true });
      const data = await fetch('/saasmerchant/web/shop/getReceiveOrderNoticeStatus', {
        params: { shopId: shop_id },
      });
      settings.setState({ switchLoading: false, audioLoading: false });
      if (data) {
        settings.setState({
          audioReceiveSwitch: Boolean(data.status),
          audioReceiveTime: data.deadLineTime,
        });
      }
    },
    // 设置接单提醒
    async updateReceiveOrderNoticeStatus(params) {
      const { shop_id } = getState().basic;
      settings.setState({ switchLoading: true, audioLoading: true });
      const data = await fetch('/saasmerchant/web/shop/updateReceiveOrderNoticeStatus', {
        params: { shopId: shop_id, ...params },
        type: 'POST',
        useJson: true,
      });
      settings.setState({ switchLoading: false, audioLoading: false });
      return data;
    },
    // 获取出餐提醒设置
    async getDeliveryOrderNoticeStatus() {
      const { shop_id } = getState().basic;
      settings.setState({ switchLoading: true, audioLoading: true });
      const data = await fetch('/saasmerchant/web/shop/getDeliveryOrderNoticeStatus', {
        params: { shopId: shop_id },
      });
      settings.setState({ switchLoading: false, audioLoading: false });
      if (data) {
        settings.setState({
          diningOutSwitch: Boolean(data.status),
          diningOutTime: data.deadLineTime,
        });
      }
    },
    // 设置出餐提醒
    async updateDeliveryOrderNoticeStatus(params) {
      const { shop_id } = getState().basic;
      settings.setState({ switchLoading: true, audioLoading: true });
      const data = await fetch('/saasmerchant/web/shop/updateDeliveryOrderNoticeStatus', {
        params: { shopId: shop_id, ...params },
        type: 'POST',
        useJson: true,
      });
      settings.setState({ switchLoading: false, audioLoading: false });
      return data;
    },
    // 发送验证码
    async sendCode(phone) {
      const { shop_id } = getState().basic;
      const data = await fetch('/merchant/sendphonecode', {
        type: 'POST',
        params: {
          shop_id,
          phone,
        },
      });
      if (data) {
        message.success('验证码已发送');
        return true;
      }
      return false;
    },
    // 更新手机号
    async updatePhone(params, callback) {
      const { shop_id } = getState().basic;
      const data = await fetch('/merchant/shop/updateshopphone', {
        type: 'POST',
        params: {
          shop_id,
          ...params,
        },
      });
      if (data) {
        message.success('修改手机号成功');
        callback && callback();
      }
    },
  }),
};

export default model;
